import { graphql } from '@e-socna/data-layer';

export const Access_Answer_Fragment = graphql(`
  fragment Access_Answer_Fragment on AccessAnswer {
    status
    details {
      kind
      fr
    }
  }
`);

export const Access_ActionAccess_Fragment = graphql(`
  fragment Access_ActionAccess_Fragment on ActionAccess {
    actionId
    status
    details {
      kind
      fr
    }
  }
`);
